import { render } from "./ylySDcreatePromotion.vue?vue&type=template&id=87a6fa1c&scoped=true"
import script from "./ylySDcreatePromotion.vue?vue&type=script&lang=js"
export * from "./ylySDcreatePromotion.vue?vue&type=script&lang=js"

import "./ylySDcreatePromotion.vue?vue&type=style&index=0&id=87a6fa1c&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a6fa1c"]])

export default __exports__